import React, { useState } from "react";
import {
  Modal,
  Form,
  Button,
  CloseButton,
  Alert,
  Spinner,
} from "react-bootstrap";
import { onboardOrganizer } from "../Api/authApi";
import {toast} from 'react-toastify';

const OrganizerOnboardModal = ({ show, handleClose, onOnboarded }) => {
  const [organizerName, setOrganizerName] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setSuccess("");
    setLoading(true);

    try {
      await onboardOrganizer(organizerName);
      setSuccess("Organizer profile created successfully!");
      toast.success('Complete you organizer profile to get verified');
      setTimeout(() => {
        handleClose();
        setOrganizerName("");
        if (onOnboarded) onOnboarded();
      }, 1500);
    } catch (err) {
      setError(err.message || "Failed to onboard organizer");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal
      show={show}
      onHide={handleClose}
      centered
      backdrop="static"
      keyboard={false}
      dialogClassName="custom-modal-size"
    >
      <Modal.Body className="auth-modal-body">
        <CloseButton onClick={handleClose} className="close-btn" />

        <div className="heading text-center mb-4">
          <h1 className="title">Become an Organizer</h1>
          <h5 className="subtitle">
            Enter your organization name to get started
          </h5>
        </div>

        {error && <Alert variant="danger">{error}</Alert>}
        {success && <Alert variant="success">{success}</Alert>}

        <Form onSubmit={handleSubmit}>
          <Form.Group className="mb-3" controlId="organizerName">
            <Form.Label>Organization Name</Form.Label>
            <Form.Control
              type="text"
              placeholder="Enter your organization name"
              onChange={(e) => setOrganizerName(e.target.value)}
              value={organizerName}
              required
            />
          </Form.Group>

          <Button
            type="submit"
            className="btn-gradient w-100 mb-3"
            disabled={loading}
          >
            {loading ? <Spinner size="sm" /> : "Create Organizer Profile"}
          </Button>
        </Form>
      </Modal.Body>
    </Modal>
  );
};

export default OrganizerOnboardModal;